import React from "react";

const Pagination = ({
  currentPage,
  totalPages,
  handlePageChange,
  itemsPerPage,
  handleItemsPerPageChange,
  indexOfFirstItem,
  indexOfLastItem,
  totalItems,
}) => {
  // Générer les numéros de page pour la pagination
  const pageNumbers = [];
  const maxPageNumbers = 5;

  if (totalPages <= maxPageNumbers) {
    // Afficher toutes les pages si le nombre total est inférieur à maxPageNumbers
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
  } else {
    // Afficher un sous-ensemble de pages avec la page actuelle au centre
    let startPage = Math.max(1, currentPage - Math.floor(maxPageNumbers / 2));
    let endPage = Math.min(totalPages, startPage + maxPageNumbers - 1);

    // Ajuster si on est proche de la fin
    if (endPage - startPage + 1 < maxPageNumbers) {
      startPage = Math.max(1, endPage - maxPageNumbers + 1);
    }

    // Ajouter la première page
    if (startPage > 1) {
      pageNumbers.push(1);
      if (startPage > 2) {
        pageNumbers.push("...");
      }
    }

    // Ajouter les pages du milieu
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    // Ajouter la dernière page
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push("...");
      }
      pageNumbers.push(totalPages);
    }
  }

  return (
    <div className="flex flex-col items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:flex-row sm:px-6">
      <div className="flex items-center">
        <p className="text-sm text-gray-700">
          Affichage de{" "}
          <span className="font-medium">{indexOfFirstItem + 1}</span> à{" "}
          <span className="font-medium">
            {Math.min(indexOfLastItem, totalItems)}
          </span>{" "}
          sur <span className="font-medium">{totalItems}</span> articles
        </p>
        <div className="ml-4">
          <select
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
            className="block w-full rounded-md border border-gray-300 bg-white py-1 pl-3 pr-10 text-sm focus:border-[#57A863] focus:outline-none focus:ring-[#57A863]"
          >
            <option value="5">5 par page</option>
            <option value="10">10 par page</option>
            <option value="25">25 par page</option>
            <option value="50">50 par page</option>
            <option value="100">100 par page</option>
          </select>
        </div>
      </div>
      <div className="mt-3 flex sm:mt-0">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium ${
            currentPage === 1
              ? "cursor-not-allowed text-gray-400"
              : "text-gray-700 hover:bg-gray-50"
          }`}
        >
          <span className="sr-only">Précédent</span>
          <svg
            className="h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        {pageNumbers.map((page, index) => (
          <button
            key={index}
            onClick={() => typeof page === "number" && handlePageChange(page)}
            disabled={page === "..."}
            className={`relative inline-flex items-center border border-gray-300 px-4 py-2 text-sm font-medium ${
              page === currentPage
                ? "z-10 border-[#4a9154] bg-indigo-100 text-[#57A863]"
                : page === "..."
                ? "cursor-default bg-white text-gray-700"
                : "bg-white text-gray-700 hover:bg-gray-50"
            }`}
          >
            {page}
          </button>
        ))}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`relative inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium ${
            currentPage === totalPages
              ? "cursor-not-allowed text-gray-400"
              : "text-gray-700 hover:bg-gray-50"
          }`}
        >
          <span className="sr-only">Suivant</span>
          <svg
            className="h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Pagination;
